export default __webpack_public_path__ + "static/media/Washington.709772ac.png";